import { Reveal, SectionHead } from "./primitives";

const CHAPTERS = [
  {
    idx: "01",
    title: "Deterministic data collection",
    body: "Operating infrastructure that collects market data — predictably, every epoch.",
  },
  {
    idx: "02",
    title: "Protocol participation",
    body: "Live participation in Flare's decentralized data protocols on Flare mainnet.",
  },
  {
    idx: "03",
    title: "Proven across reward epochs",
    body: "Reliability and performance are measured continuously across completed reward epochs.",
  },
];

export default function About() {
  return (
    <section className="section" id="about" data-testid="about-section">
      <div className="wrap about-grid">
        <div className="about-sticky">
          <SectionHead index="01" label="About" title="Deterministic by design." />
        </div>
        <div>
          <Reveal>
            <p className="about-lede">
              We operate deterministic infrastructure that collects market data and participates in Flare's
              decentralized data protocols. Our focus is <em>reliability and performance</em>, measured continuously
              across reward epochs on Flare mainnet.
            </p>
          </Reveal>
          <div>
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.idx} delay={i * 0.08}>
                <div className="chapter">
                  <span className="chapter-idx">{c.idx}</span>
                  <div>
                    <h3>{c.title}</h3>
                    <p>{c.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
